// Cookie Consent Management

import { config } from './config.js';

const COOKIE_CONSENT_KEY = 'reforge_cookie_consent';

/**
 * Initialize cookie consent banner
 */
export function initCookieConsent() {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
        setTimeout(() => {
            const banner = document.getElementById('cookieConsent');
            if (banner) {
                banner.classList.add('show');
            }
        }, config.ui.cookieBannerDelay);
    } else if (consent === 'accepted') {
        enableAnalytics();
    }
}

/**
 * Accept cookies
 */
export function acceptCookies() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    const banner = document.getElementById('cookieConsent');
    if (banner) {
        banner.classList.remove('show');
    }
    enableAnalytics();
}

/**
 * Decline cookies
 */
export function declineCookies() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'essential');
    const banner = document.getElementById('cookieConsent');
    if (banner) {
        banner.classList.remove('show');
    }
}

/**
 * Enable analytics after consent
 */
function enableAnalytics() {
    // Initialize analytics only after consent
    // Example: if (typeof gtag !== 'undefined') { gtag('consent', 'update', { analytics_storage: 'granted' }); }
}
